import React from 'react';

const FaqSideItem = ({ topic, isSelected, onSelect }) => {
  return (
    <div className='flex flex-col items-start gap-3'>
      <button
        onClick={() => onSelect?.(topic.slug)}
        className={`typo-b12 text-left transition-colors ${
          isSelected
            ? 'text-text-accent underline'
            : 'text-text-secondary hover:text-text-primary'
        }`}
      >
        {topic.title}
      </button>
    </div>
  );
};

export default FaqSideItem;
